export default __webpack_public_path__ + "static/undraw_Agreement-3c0b242ea04bb5abdd671c6bf79a8c7c.svg";